module.exports = __webpack_public_path__ + "media/images/icons/exam-preparation-b542004b4303a536bbfcd8f8659ef650.svg";